import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SeedField extends BaseOption {
  static userInterfaceComponent = {
    label: "Show saved value from",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
